<template>
    <div class="d-flex align-items-center">
        <animal-avatar :thumbnail-absolute-path="value['thumbnail']" :size="48" :species="value.species" />
        <div class="d-flex flex-column">
            <div class="mb-1">
                <slot name="value">
                    <div class="d-flex flex-column">
                        <span>
                            <b-link :to="{ name: 'animalDetail', params: { id: value.id } }"><strong>№{{ value['reg_number'] }}</strong></b-link>
                            <b-icon v-if="value['reviewed']" icon="check-circle-fill" variant="success" class="ml-1" v-b-tooltip="getReviewTooltip()"/>
                            <b-icon v-if="!value['reviewed'] && value['review_date']" icon="question-circle-fill" variant="warning" class="ml-1" v-b-tooltip="getStaleReviewTooltip()"/>
                        </span>
                        <b-link :to="{ name: 'animalDetail', params: { id: value.id } }"><span class="text-nowrap">{{ value['shelter_reg_number'] }}</span></b-link>
                        <span class="text-secondary d-flex flex-column">
                            <small class="mb-1">
                                <span>{{ value['species_name'] }}</span>
                                <span v-if="value['breed_name']">, {{ value['breed_name'].toString().toLowerCase() }}</span>
                            </small>
                            <small  class="mb-1" v-if="value['label_id']">бирка <strong>{{ value['label_id'] }}</strong></small>
                            <small v-if="value['chip_id']">чип <strong>{{ value['chip_id'] }}</strong></small>
                        </span>
                    </div>
                </slot>
            </div>
            <div class="mb-1">
                <slot name="secondary">
                    <span class="tag danger" v-if="canViewIsAggressive() && getIsAggressive()">Агрессивное</span>
                </slot>
            </div>
        </div>
    </div>

</template>

<script>
import AnimalAvatar from "@/pages/AppPages/Animals/AnimalAvatar.vue";
import dog from "@/assets/img/dog.png";
import cat from "@/assets/img/cat.png";
import {mapGetters} from "vuex";
import {ACTIVITIES} from "@/store/auth/auth";

export default {
    name: "AnimalAvatarInfoCell",
    components: {AnimalAvatar},
    props: {
        value: {},
        extraValue: {}
    },
    data() {
        return {
            dog,
            cat
        }
    },
    computed: {
        ...mapGetters(['isSuperuser', 'isInController', 'isMunicipalController', 'userOrganizationActivities']),
    },
    methods: {
        getReviewTooltip() {
            return 'Проверено ' + this.value['review_date']
        },
        getStaleReviewTooltip() {
            return `После проверки ${this.value['review_date']} были внесены изменения`;
        },
        canViewIsAggressive() {
            return this.isSuperuser || !this.isSuperuser && this.isInController
                && this.userOrganizationActivities.includes(ACTIVITIES.CONTROL) && !this.isMunicipalController;
        },
        getIsAggressive() {
            return this.extraValue.length > 0 ? this.extraValue[0] : null
        }
    }
}
</script>

<style scoped lang="scss">
    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";
    .tag {
        background-color: lighten($primary, 42%);
        border-radius: 12px;
        padding: 5px 12px;
        margin-right: 7px;
        margin-top: 5px;
        &.danger {
            background-color: lighten($danger, 42%);
        }
    }
</style>